import { createStore, useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import _ from 'lodash';
import { GTMsendEvent } from 'src/utils/trackingGA4';

type RequestQuoteVehicle = {
  marca?: string;
  modello?: string;
  allestimento?: string;
  images?: string[];
}

type StellantisStore = {
  isRequestQuoteOpen: boolean;
  isEnabled: boolean;
  requestQuoteVehicle: RequestQuoteVehicle | null;
  openRequestQuoteModal: (vehicle?: RequestQuoteVehicle, source?: string) => void;
  closeRequestQuoteModal: () => void;
  setEnabled: (isEnabled: boolean) => void;
};

export const stellantisStore = createStore<StellantisStore>(
  (set, get) => ({
    isRequestQuoteOpen: false,
    isEnabled: true,
    requestQuoteVehicle: null,
    openRequestQuoteModal: (vehicle?: RequestQuoteVehicle, source?: string) => {
      set({ isRequestQuoteOpen: true, requestQuoteVehicle: vehicle ?? null });
      try {
        GTMsendEvent({
          event: 'CTA_quote_request',
          evtCat: 'quote_request',
          evtAct: 'click',
          evtLab: source ?? 'unknown',
        });
      } catch (error) {
        console.warn('[Horizon] Failed to send Stellantis quote request CTA event.', error);
      }
    },
    closeRequestQuoteModal: () => set({ isRequestQuoteOpen: false, requestQuoteVehicle: null }),
    setEnabled: (isEnabled: boolean) => set({ isEnabled })
  }),
);

export function useStellantisState() {
  return useStore(
    stellantisStore,
    useShallow((state) => ({
      isEnabled: state.isEnabled,
      isRequestQuoteOpen: state.isRequestQuoteOpen,
      requestQuoteVehicle: state.requestQuoteVehicle,
    })),
  );
}

export function useStellantisActions() {
  return useStore(
    stellantisStore,
    useShallow((state) => ({
      openRequestQuoteModal: state.openRequestQuoteModal,
      closeRequestQuoteModal: state.closeRequestQuoteModal,
    })),
  );
}
